import { render, staticRenderFns } from "./TestOverview.vue?vue&type=template&id=0068efba"
import script from "./TestOverview.vue?vue&type=script&lang=js"
export * from "./TestOverview.vue?vue&type=script&lang=js"
import style0 from "./TestOverview.vue?vue&type=style&index=0&id=0068efba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TestOverview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "./TestOverview.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports